export const getIndexedLabel = (label: string, index: number, count: number): string => {
  return count > 1 ? `${label} (${index + 1})` : label
}

export const getActionTargetAriaLabel = (label: string, objectLabel: string): string => {
  return `${label} ${objectLabel}`
}
